import { Row } from '@tanstack/react-table';
import { ToDoRowModel } from '../entities/Entities';
import { Konflikt } from '../entities/Konflikt';
import dayjs, { Dayjs } from 'dayjs';
import { Antrag } from '../entities/Antrag';
import { Abwesenheit } from '@/domain/arbeitszeiten/components/Table/ToDoTable/entities/Abwesenheit';

// oxlint-disable-next-line complexity
function getStartTime(row: Row<ToDoRowModel>): Dayjs | undefined {
  if (row.original instanceof Konflikt) {
    if (row.original.rootArbeitszeit instanceof Abwesenheit) {
      return dayjs();
    }
    return row.original.rootArbeitszeit?.beginn?.zeitpunkt;
  }
  if (row.original instanceof Antrag) {
    return row.original.beginn?.zeitstempel.zeitpunkt;
  }

  return row.original?.beginn?.zeitpunkt;
}

export function sortArbeitszeit(
  rowA: Row<ToDoRowModel>,
  rowB: Row<ToDoRowModel>,
): number {
  const startA = getStartTime(rowA);
  const startB = getStartTime(rowB);

  if (!startA) return 1;
  if (!startB) return -1;

  if (startA < startB) return -1;
  if (startA > startB) return 1;

  return 0;
}
